
function formatDate(timestamp) {
  let date = new Date(timestamp);
  let hours = date.getHours();
  if (hours < 10) {
    hours = `0${hours}`;
  }
  let minutes = date.getMinutes();
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  let days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  let day = days[date.getDay()];
  return `${day} ${hours}:${minutes}`;
}

function formatDay(timestamp) {
  let date = new Date(timestamp * 1000);
  let day = date.getDay();
  let days = ["Sunday", "Monday", "Tuesday", "Wednesday",  "Thursday",  "Friday",  "Saturday",];

  return days[day];
}


//////////////////////////////////////////////
function display (response){
  let forecastt = response.data.daily;
  let forecast = document.querySelector("#weater-f");
  let forecastHTML = ` <div class="row">`;
 
  forecastt.forEach(function(forecastDay, index){
    if (index < 5) {
   forecastHTML =  forecastHTML + `
 
  <div class="col">
    <div class="date-forecast">${formatDay(forecastDay.dt)}</div>
    <img
    src="http://openweathermap.org/img/wn/${forecastDay.weather[0].icon}@2x.png" alt=""    width="42"       />
    <div class="weather-forecast-t"> 
       <span class="temp-day-max">${Math.round(forecastDay.temp.max)}°</span>
       <span class="temp-day-min">/${Math.round( forecastDay.temp.min )}°</span>
    </div>
  </div>
`;}
  })

forecastHTML =  forecastHTML + `</div>`
forecast.innerHTML = forecastHTML;
}
////////////////////////////////////////////////////

function getForecast(coordinates) {
  let apiKey = "5f472b7acba333cd8a035ea85a0d4d4c";
  let apiUrl = `https://api.openweathermap.org/data/2.5/onecall?lat=${coordinates.lat}&lon=${coordinates.lon}&appid=${apiKey}&units=metric`;
  axios.get(apiUrl).then(display);
}
////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////
function displayTemperature(response) {
  // let temperatureElement = document.querySelector("#temperature");
  let city = document.querySelector("#city");
  let humidity = document.querySelector("#humidity");
  let descriptionElement = document.querySelector("#description");
  let wind = document.querySelector("#wind");
  let dateElement = document.querySelector("#date");
  let iconElement = document.querySelector("#icon");

  city.innerHTML = response.data.name;
  descriptionElement.innerHTML = response.data.weather[0].description;
  humidity.innerHTML = response.data.main.humidity;
  wind.innerHTML = Math.round(response.data.wind.speed);
  dateElement.innerHTML = formatDate(response.data.dt * 1000);
  iconElement.setAttribute("src", `http://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png` );
  iconElement.setAttribute("alt", response.data.weather[0].description);

  getForecast(response.data.coord);
}
////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////
function search(city) {
  let apiKey = "5f472b7acba333cd8a035ea85a0d4d4c";
  let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
  axios.get(apiUrl).then(displayTemperature);
}
/////////////////////////////////////////////////////////////
function handleSubmit(event) {
  event.preventDefault();
  let cityInputElement = document.querySelector("#city-input");
  search(cityInputElement.value);
}

let form = document.querySelector("#search-form");
form.addEventListener("submit", handleSubmit);

//////////////////////////////////////////////////////////

// function showFahrrenheitTemp(event){
//   event.preventDefault();
//   let temperature = document.querySelector("#temperature");
//   celsiusLink.classList.remove("active");
//   fahrenheitLink.classList.add("active");
//   let farTemp = (temperature.innerHTML * 9) / 5 + 32;
 
//   temperature.innerHTML = Math.round(farTemp);

// }

// function showCelsiusTemp(event){
//   event.preventDefault();
//   celsiusLink.classList.add("active");
//   fahrenheitLink.classList.remove("active");
//   let temperature = document.querySelector("#temperature");
//   temperature.innerHTML = Math.round(celsiusTemperature);
// }

// let celsiusTemperature = null;


// let fahrenheitLink = document.querySelector("#fahrenheit-link");
// fahrenheitLink.addEventListener("click", showFahrrenheitTemp);

// let celsiusLink = document.querySelector("#celsius-link");
// celsiusLink.addEventListener("click", showCelsiusTemp);


search("Kyiv");

